<template>
  <transition name="zoom-fade">
    <router-view />
  </transition>
</template>

<script>
export default {
  name: "OrganizationsIndex",
};
</script>

<style>
</style>